<template>
  <div
    id="wallet"
    class="mpesa"
  >
    <div class="row">
      <div class="col-md-6">
        <div class="stk-push">
          <h6>Option One</h6>
          <p>
            Enter your phone number (07XXXXXXXX) to receive a payment request on your phone. All you have to
            do is input your m-pesa pin.
          </p>
          <form
            data-vv-scope="form1"
            @submit.prevent="validateForm('form1')"
          >
            <div class="form-group">
              <label>Company</label>
              <v-select
                v-model="selected_company"
                v-validate="'required'"
                :options="agents"
                label="name"
                name="company"
                data-vv-scope="form1"
                placeholder="Select your Company"
              />
              <div :class="{'invalid-feedback': errors.has('form1.company')}">
                {{ errors.first('form1.company') }}
              </div>
            </div>
            <div class="form-group">
              <label>Phone Number</label>
              <input
                v-model="stk_phone_number"
                v-validate="'required|digits:10'"
                type="text"
                class="form-control"
                name="phone"
                data-vv-scope="form1"
                :class="{'is-invalid': errors.has('form1.phone')}"
              >
              <div :class="{'invalid-feedback': errors.has('form1.phone')}">
                {{ errors.first('form1.phone') }}
              </div>
            </div>
            <div class="form-group">
              <label>Amount</label>
              <vue-numeric
                v-model="amount"
                v-validate="'required'"
                name="amount"
                placeholder="Enter amount"
                data-vv-scope="form1"
                class="form-control"
                :class="{'is-invalid': errors.has('form1.amount')}"
              />
              <div :class="{'invalid-feedback': errors.has('form1.amount')}">
                {{ errors.first('form1.amount') }}
              </div>
            </div>
            <div class="form-group">
              <a
                v-if="stk_waiting"
                href="#"
                class="btn btn-primary pull-right btn-loading"
              >
                <i class="fa fa-spin fa-spinner" /> Waiting for payment</a>
              <button
                v-else
                type="submit"
                class="btn btn-primary pull-right"
              >
                Load Wallet
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="col-md-6">
        <div class="manual">
          <h6>Option Two</h6>
          <p>Follow the instructions below:</p>
          <ul>
            <li>Go to m-pesa menu</li>
            <li>Select lipa na mpesa</li>
            <li>Select pay bill</li>
            <li>Enter paybill number <strong>{{ mpesa_paybill }}</strong></li>
            <li>
              Enter account number <strong v-if="selected_company">AW{{ selected_company.secret
              }}</strong>
            </li>
            <li>Enter the amount</li>
            <li>Enter your pin and send</li>
          </ul>
          <p>Once you receive the confirmation SMS, enter the transaction code in the box below</p>
          <form
            data-vv-scope="form2"
            @submit.prevent="validateForm('form2')"
          >
            <div class="form-group">
              <label>Transaction Code</label>
              <input
                v-model="transaction_code"
                v-validate="'required'"
                type="text"
                name="transaction_code"
                placeholder="XXXXXX"
                class="form-control"
                :class="{'is-invalid': errors.has('form2.transaction_code')}"
              >
              <div :class="{'invalid-feedback': errors.has('form2.transaction_code')}">
                {{ errors.first('form2.transaction_code') }}
              </div>
            </div>
            <div class="form-group">
              <button
                type="submit"
                class="btn btn-primary pull-right"
              >
                Verify Payment
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {

        data() {
            return {
                error: '',
                stk_phone_number: '',
                transaction_code: '',
                amount: '',
                confirmed: false,
                loading: false,
                message: [],
                agents: [],
                selected_company: {secret: '', name: ''},
                stk_waiting: false
            }
        },

        computed: {
            mpesa_paybill() {
                return process.env.VUE_APP_MPESA_PAYBILL;
            }
        },
        mounted() {
            this.fetch();
        },

        methods: {
            fetch() {
                this.$axios.get('/api/v1/agents/options').then(response => {
                    this.agents = response.data;
                    if (this.agents.length > 0) {
                        this.selected_company = this.agents[0];
                    }
                    this.loading = false;
                });
            },
            validateForm(scope) {
                return this.$validator.validateAll(scope).then(result => {
                    if (result) {
                        if (scope === 'form1') this.requestSTK();

                        if (scope === 'form2') this.confirmTrx()
                    }
                });
            },
            requestSTK() {
                let data = {
                    phone: this.stk_phone_number,
                    account: 'AW' + this.selected_company.secret,
                    amount: this.amount
                };
                this.stk_waiting = true;
                this.$axios.post('/api/v1/initiate-stk', data).then(() => {
                    this.$toastr.i("A push notification of KES " + this.amount + " for payment has been sent to " + this.stk_phone_number);
                    this.confirmPayment();
                });
            },

            confirmPayment() {
                const self = this;
                let attempts = 0;
                self.loading = true;
                let interval = setInterval(function () {
                    this.$axios.post('/api/v1/confirm-payment', {
                        account: 'AW' + self.selected_company.secret,
                        expected_amount: self.amount
                    }).then(response => {
                        if (response.data.confirmed) {
                            self.stk_waiting = false;
                            self.loading = false;
                            clearInterval(interval);
                            this.$toastr.s(response.data.message);
                            setTimeout(() => {
                                window.location.reload();
                            }, 1000);
                        } else {
                            attempts += 1;
                            if (attempts === 10) {
                                self.stk_waiting = false;
                                self.loading = false;
                                clearInterval(interval);
                                attempts = 0;
                                this.$toastr.e("Took too long to perform payment.Retry confirm", "Timeout");
                            }
                        }
                    }).catch(err => {
                        self.stk_waiting = false;
                        self.loading = false;
                        clearInterval(interval);
                        this.error = err.response;
                    });
                }, 5000);

            },

            confirmTrx() {
                this.error = "";
                this.loading = true;
                this.$axios.post('/api/v1/confirm-transaction', {
                    account: 'AW' + this.selected_company.secret,
                    transaction_code: this.transaction_code
                }).then(response => {
                    if (response.data.confirmed) {
                        this.$toastr.s(response.data.message);
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);
                    } else {
                        this.loading = false;
                        this.$toastr.e("Could not find this payment", "Payment not found");
                    }
                }).catch(err => {
                    this.loading = false;
                    this.error = err.response;
                });
            },
        }
    }
</script>
<style lang="scss">
    #wallet {
        padding: 20px 0;

        .manual {
            border-left: 1px dotted #aaa;
            padding-left: 20px;

            @media (max-width: 480px) {
                border-top: solid 1px #ddd;
                margin-top: 30px;
                padding-top: 10px;
                border-left: none;
                padding-left: 0;
            }
        }
    }
</style>
